import { IFaireFundedPromo } from "@faire/web-api/indigofair/data/IFaireFundedPromo";
import { useCurrencyStore } from "@faire/web/common/currency/CurrencyStore";
import { moneyOrZero } from "@faire/web/common/money";
import { useState } from "@faire/web/ui/hooks/useState";
import { useEffect } from "react";

import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

import { useFetchCachedBrandView } from "../../hooks/useFetchCachedBrandView";

export const useBrandCartHeader = (brandToken: string) => {
  const {
    isNewOrMigratedCanadian,
    displayCurrency,
    isQualifiedForEuropeFreeShipping,
  } = useRetailerStore([
    "isNewOrMigratedCanadian",
    "displayCurrency",
    "isQualifiedForEuropeFreeShipping",
  ]);
  const [
    isBrandEligibleForUkEuBrandsFreeShipping,
    setIsBrandEligibleForUkEuBrandsFreeShipping,
  ] = useState<boolean>(false);

  const { setCurrency } = useCurrencyStore(["setCurrency"]);

  useEffect(() => {
    // TODO(bocong.zhao@faire.com, 2024/02/14): Remove when we relaunch Canada.
    if (isNewOrMigratedCanadian) {
      setCurrency(undefined);
    }
  }, [isNewOrMigratedCanadian, setCurrency]);

  const { data } = useFetchCachedBrandView(brandToken ?? "");

  const brand = data?.brand;

  const faireFundedPromos: IFaireFundedPromo[] = data?.faire_funded_promo ?? [];

  const brandMinimumAmount = moneyOrZero(
    brand?.minimum_order_amount,
    displayCurrency
  );
  const showVerticalImagery = brand?.is_apparel ?? false;

  const fetchFreeShippingStatus = (retailerToken?: string) => {
    if (!retailerToken) {
      return;
    }
    setIsBrandEligibleForUkEuBrandsFreeShipping(
      data?.eligible_for_uk_eu_brands_free_shipping ?? false
    );
  };

  const hasUkEuBrandsFreeShipping =
    isQualifiedForEuropeFreeShipping &&
    isBrandEligibleForUkEuBrandsFreeShipping;

  return {
    brand,
    firstOrder: brand?.is_first_order ?? false,
    brandMinimumAmount,
    brandName: brand?.name,
    showVerticalImagery,
    faireFundedPromos,
    fetchFreeShippingStatus,
    hasUkEuBrandsFreeShipping,
  };
};
